import { Component, inject, Input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ModalService } from '../../../shared/services/modal/modal.service';
import { historiqueBilatStore } from '../../store/historique-bilat.store';

@Component({
  selector: 'app-comment-modal-bilat',
  templateUrl: './comment-modal-bilat.component.html',
  styleUrls: ['./comment-modal-bilat.component.scss'],
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule],
})
export class CommentModalBilatComponent {
  readonly store = inject(historiqueBilatStore);
  private readonly modalService = inject(ModalService);

  @Input() toggle: boolean = false;
  @Input() bilatId: number = 0;

  commentControl: FormControl<string> = new FormControl<string>('', { nonNullable: true, validators: [Validators.required] });

  constructor() {}

  onSubmit(): void {
    if (this.commentControl.invalid) return;

    this.store.setComment(this.bilatId, this.commentControl.value.trim(), true);
    this.closeModal();
  }

  closeModal(): void {
    localStorage.removeItem('pendingBilatComment');
    this.modalService.closeBilatComment();
    this.commentControl.reset();
  }
}
